import ProductSearch from "./productSearch.container";

export default ProductSearch;